import type { Course } from "@shared/models/course"
import type { ReactNode } from "react"

interface Props {
  course: Course
  /** The unit's menu. */
  menu: ReactNode
}

/**
 * The COURSE's title, in the small grey caps Ember's unit header used, with the unit's menu
 * opposite it. It sits directly above the editor so the course reads as a kicker over the
 * unit's own topic, which is the editor's title.
 */
export default function UnitTitleBar({ course, menu }: Props) {
  return (
    <div
      className="@container flex cursor-default items-center justify-between gap-2 text-xs leading-none"
      data-test="unit title bar"
    >
      <div className="min-w-0 flex-1 font-medium wrap-anywhere text-secondary-text uppercase select-none">
        {course.attributes.title}
      </div>
      <div className="flex shrink-0 items-center gap-1.5">{menu}</div>
    </div>
  )
}
